import Alert from './Alert';

export default Alert;



// WEBPACK FOOTER //
// ./src/Components/Feedback/Components/Alert/index.tsx